import { render, staticRenderFns } from "./BankTab.vue?vue&type=template&id=6b257f93&scoped=true"
import script from "./BankTab.vue?vue&type=script&lang=js"
export * from "./BankTab.vue?vue&type=script&lang=js"
import style0 from "./BankTab.vue?vue&type=style&index=0&id=6b257f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b257f93",
  null
  
)

export default component.exports